"use client";
import React, { ReactNode, useEffect } from "react";
import { getDictionary } from "../dictionaries/dictionaries";

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
};

const getLocalStorageItem = (key: string): string | null => {
  if (typeof window !== "undefined") {
    return localStorage.getItem(key);
  }
  return null;
};

const setLocalStorageItem = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

const removeLocalStorageItem = (key: string): void => {
  localStorage.removeItem(key);
};

const getTranslations = async (): Promise<Record<string, any>> => {
  removeLocalStorageItem("site_strings");
  const lang = getCookie("site_lang") || "eng";
  if (lang !== "eng") {
    const dict = await getDictionary(lang as any);
    setLocalStorageItem("site_strings", JSON.stringify(dict));
    return dict;
  } else {
    const dict = await getDictionary(lang as any);
    setLocalStorageItem("site_strings", JSON.stringify(dict));
    return dict;
  }
};

interface LocalizationProviderProps {
  children?: ReactNode;
}

export function LocalizationProvider({ children }: LocalizationProviderProps) {
  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        await getTranslations();
      } catch (error) {
        console.error("Error fetching translations:", error);
      }
    };

    fetchTranslations();
  }, []);

  return <>{children}</>;
}

export const useLocalization = () => {
  const dict = getLocalStorageItem("site_strings");
  return JSON.parse(dict || "{}");
};
